import React, { useState, useEffect } from 'react'

import apiCall, { TEST_URL, LIVE_URL } from '~/utils/apiCall';
import SearchInput from '../../../components/SearchInput'

import { Container, SearchArea } from './styled'

const ModalContentContainer = ({ closeModal, setState }) => {
  
  const initSearchList = {
    list: [],
    isLoading: false,
  };
  const [ searchList_ServerState, setSearchList_ServerState ] = useState(initSearchList);
  const { list, isLoading } = searchList_ServerState;

  const [ inputValue, setInputValue ] = useState('');
  
  useDebounce(
    () => {
      onChangeSubmit(inputValue);
    },
    1000,
    inputValue
  );
  
  function useDebounce(func, delay, trackValue) {
    let timer = {};
    useEffect(() => {
      if (trackValue) {
        timer = setTimeout(() => {
          func()
        }, delay);
        return () => {
          clearTimeout(timer);
        }
      }
    }, [trackValue]);
  }

  const setLocation = value => {
    setState(prev=> ({...prev, address: value?.fullName}));
    closeModal();
  }

  const onHandleChange = e => {
    setInputValue(e.target.value);
    e.target.value !== '' ? 
    setSearchList_ServerState(prev => ({ ...prev, isLoading: true })) :
    setSearchList_ServerState(initSearchList);
  }

  const onChangeSubmit = async inputValue  => {
    const host = process.env.NODE_ENV === 'development' ? TEST_URL : LIVE_URL
    try {
      const { result } = await apiCall.get(`${host}/api/v1/regions`, { keyword: inputValue });
      setSearchList_ServerState({ list: result, isLoading: false });
    } catch (err) {
      console.log(err);
      setSearchList_ServerState(initSearchList);
      alert(err?.msg ?? '서버에러가 발생했습니다.');
    }
  };

  return (
    <Container> 
      <SearchInput 
        inputValue={inputValue} 
        onHandleChange={onHandleChange} 
        isLoading={isLoading} 
        list={list}
        setLocation={setLocation}
      />
      <SearchArea onClick={closeModal}>닫기</SearchArea>
    </Container>
  )
}
export default ModalContentContainer;